import { render, staticRenderFns } from "./ReplyAudio.vue?vue&type=template&id=90af7704&scoped=true&"
import script from "./ReplyAudio.vue?vue&type=script&lang=js&"
export * from "./ReplyAudio.vue?vue&type=script&lang=js&"
import style0 from "./ReplyAudio.vue?vue&type=style&index=0&id=90af7704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90af7704",
  null
  
)

export default component.exports